import React, { Component } from 'react';

import { Redirect } from 'react-router-dom';

import { connect } from 'react-redux';
import AuthDuck from '../../ducks/AuthDuck';

import { LOCALSTORAGE_KEY } from '../../config/constants';

class IndexPage extends Component {
  componentWillMount() {
    console.log('Loading settings from localStorage...');
    const settingsJson = localStorage.getItem(LOCALSTORAGE_KEY);
    let isAuthenticated = false;
    if (settingsJson) {
      try {
        const settings = JSON.parse(settingsJson);
        if (settings && settings.email && settings.token) {
          console.log('Loaded settings from localStorage: ', settings);
          this.props.updateAuthentication(settings.email, settings.token);
          isAuthenticated = true;
        }
      } catch (_) {
        // Ignore
      }
    }
    console.log('IndexPage.isAuthenticated = ', isAuthenticated);
    this.setState({
      isAuthenticated,
    });
  }

  render() {
    console.log('@@@@@@@@@@ isAuthenticated = ' + this.state.isAuthenticated);
    if (this.state.isAuthenticated) {
      return <Redirect to="/transfers" />;
    } else {
      return <Redirect to="/login" />;
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateAuthentication: (email, token) => {
      return dispatch(AuthDuck.creators.updateAuthentication(email, token));
    },
  };
};

export default connect(null, mapDispatchToProps)(IndexPage);
